module.exports = __webpack_public_path__ + "static/media/Uruli-L.751afb6f.jpeg";